export const primaryColor = "#3d2f27"
